function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 4.99999V4.5C14.5 3.11929 13.3807 2 12 2H8C6.61929 2 5.5 3.11929 5.5 4.5V4.99999",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.01084 6.69454L1.75336 8.36064C1.60643 9.31133 2.15712 10.2319 3.06425 10.5521L8.66872 12.5301C9.5302 12.8342 10.4698 12.8342 11.3313 12.5301L16.9358 10.5521C17.8429 10.2319 18.3936 9.31133 18.2466 8.36064L17.9892 6.69454C17.8385 5.71949 16.9992 5 16.0126 5H3.98738C3.00075 5 2.16153 5.71949 2.01084 6.69454Z",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 12V16C2.5 17.1046 3.39543 18 4.5 18H15.5C16.6046 18 17.5 17.1046 17.5 16V12",
  stroke: "black",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgProvider = function SvgProvider(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProvider, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/provider.255d561e.svg";
export { ForwardRef as ReactComponent };